import { Paginator, SortDirection } from '@app/classes';
import { WorkersCompensationAssignedEmployee } from '@app/models/payroll/workers-compensation-assigned-employee.model';
import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import { DepartmentColumn, FullNameColumn, PositionColumn } from '@employees/services/tables/employee-table/columns';

const pageSize = 5;

export class EmployeeWorkersCompensationTable extends Table {
    sortDirection = SortDirection.ASC;
    links = false;
    bulkSelect = false;
    protected sortProperty = 'name';

    constructor(
        protected auth: AuthService,
        private workersCompensationId: number
    ) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        const nameColumn = new FullNameColumn();
        this.sortColumn = nameColumn;
        this.columns = [
            nameColumn,
            new PositionColumn(this.auth.company.id),
            new DepartmentColumn(this.auth.company.id),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            WorkersCompensationAssignedEmployee.param('company', this.auth.company.id)
                .param('workersCompensation', this.workersCompensationId)
                .where('status', ['active', 'terminated', 'on leave'])
                .where('isWcbExempt', false)
                .with(['job', 'department'])
                .limit(pageSize),
            {
                pageSize: pageSize,
            }
        );
    }
}
